export type BadgeSizesTypes = 'lg' | 'md' | 'sm' | 'xs' | 'default';
export type BadgeVariantTypes = 'default' | 'outline';

export const badgeSizes: Record<BadgeSizesTypes, string> = {
  default: '',
  lg: 'badge-lg',
  md: 'badge-md',
  sm: 'badge-sm',
  xs: 'badge-xs',
};

export const badgeColors: Record<string, string> = {
  default: '',
  primary: 'badge-primary',
  secondary: 'badge-secondary',
  accent: 'badge-accent',
  neutral: 'badge-neutral',
  ghost: 'badge-ghost',
  success: 'badge-success',
  error: 'badge-error',
  warning: 'badge-warning',
  info: 'badge-info',
};

export const badgeVariants: Record<BadgeVariantTypes, string> = {
  default: '',
  outline: 'badge-outline',
};
